






































































































import { Vue, Component } from "vue-property-decorator";
import PageLoading from "@/pages/showDetail/PageLoading.vue";
import CallPhone from "@/pages/showDetail/CallPhone.vue";
import getUrlParam from "../../common/utils/getUrlParam";
import fetch from "@/common/api/fetch";
import { AxiosPromiseData } from "../../common/interface";
import formatDate from '@/common/filters/formatDate';

@Component({
  components: {
    "call-phone": CallPhone,
    "show-page-loading": PageLoading
  }
})
export default class DistributionCommissionList extends Vue {
  chooseTab: string = "rank";
  loading: boolean = false;
  achievedNumber: string = "0";
  allDealAmount: string = "0";
  enableLevelTwo: boolean = false;
  joinedNumber: string = "0";
  rankList: any = {};
  flowList: any = {};
  distributionLevelMap = {
    1: "一级分销",
    2: "二级分销"
  };
  formatDate: Function = formatDate;
  mounted() {
    document.title = '佣金记录';
    this.getDistributionRank();
  }

  handleChangeTab(tab: string) {
    if (this.chooseTab !== tab) {
      this.chooseTab = tab;
      if (tab === "rank") {
        this.getDistributionRank();
      }
      if (tab === "flow") {
        this.getDistributionFlow();
      }
    }
  }

  getDistributionRank() {
    this.loading = true;
    const param = {
      activityId: getUrlParam("broadcastId"),
      current: 1,
      size: 1000
    };
    fetch
      .Sales("public/distribute/getDistributorTopRecords", param)
      .then((res: AxiosPromiseData) => {
        this.loading = false;
        this.achievedNumber = res.result.achievedNumber;
        this.enableLevelTwo = res.result.enableLevelTwo;
        this.allDealAmount = res.result.allDealAmount;
        this.joinedNumber = res.result.joinedNumber;
        this.rankList = res.result.records;
      });
  }

  getDistributionFlow() {
    this.loading = true;
    const param = {
      activityId: getUrlParam("broadcastId"),
      current: 1,
      size: 1000
    };
    fetch
      .Sales("public/distribute/getDistributorFlows", param)
      .then((res: AxiosPromiseData) => {
        this.loading = false;
        this.allDealAmount = res.result.allDealAmount;
        this.flowList = res.result.records;
      });
  }
}
